import React, { useContext } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';
import Button from '@prisjakt/ui-button';
import T from '@prisjakt/ui-translate';

import {
  ErrorMessageWrapper,
  ErrorMessageMedia,
  ErrorMessageContent,
  ErrorMessageButton,
  ErrorMessageErrorLabel,
  ErrorMessageSupportLabel,
  ErrorMessageTitle,
  ErrorMessageSubtitle,
  ErrorMessageHidden,
} from './styles';

type ErrorMessageProps = {
  message?: string;
  stack?: string;
  status?: number;
  onRetry?: () => void;
};

/*
  When using compose from DataContainer we can only get
  the contexts requested by the DataContainer component.
*/
const ErrorMessage: React.FC<ErrorMessageProps> = ({
  status = 500,
  message,
  stack,
  onRetry,
}) => {
  const {
    market: { cdn },
    t,
  } = useContext(AppContext);

  return (
    <ErrorMessageWrapper data-test="ErrorMessage" data-status={status}>
      <ErrorMessageMedia>
        <img alt="Error" src={`${cdn}/rfe/g/error_page_io.png`} />
      </ErrorMessageMedia>

      <ErrorMessageContent>
        <div>
          <ErrorMessageTitle>
            {t('errors', 'error-page.title')}
          </ErrorMessageTitle>
          {status === 404 && (
            <ErrorMessageSubtitle>
              {t('errors', 'internal.404')}
            </ErrorMessageSubtitle>
          )}
          {status > 499 && (
            <ErrorMessageSubtitle>
              {t('errors', 'internal.unknown')}
            </ErrorMessageSubtitle>
          )}
          <ErrorMessageButton>
            {onRetry ? (
              <Button onClick={onRetry}>
                {t('errors', 'error-page.retry-button')}
              </Button>
            ) : (
              <a href="/">
                <Button>{t('errors', 'error-page.go-home-button')}</Button>
              </a>
            )}
          </ErrorMessageButton>
        </div>

        {status > 499 && (
          <ErrorMessageSupportLabel>
            <T domain="errors">support.text-link.md</T>
          </ErrorMessageSupportLabel>
        )}

        {status && (
          <ErrorMessageErrorLabel>
            {t('errors', 'error-page.error-code', { code: status })}
          </ErrorMessageErrorLabel>
        )}
        {/* TODO: Why render these and then hide them? */}
        <ErrorMessageHidden>{message}</ErrorMessageHidden>
        <ErrorMessageHidden>{stack}</ErrorMessageHidden>
      </ErrorMessageContent>
    </ErrorMessageWrapper>
  );
};

export default ErrorMessage;
